import React, { Component } from 'react';
import { toast, ToastContainer, MDBCardText, MDBCard, MDBCardTitle, MDBRow, MDBCol, MDBBtn, MDBIcon, MDBInput, MDBInputGroup, MDBContainer, MDBBadge } from 'mdbreact';
import Header from './ComponentFragments/Header';
import DataLayer from '../Utilities/DataLayer';
import Formatter from '../Utilities/Formatter';
import Colors from '../Styles/Colors';


class DispatchList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dispatchList: []
        }
        this.formatter = new Formatter();
        this.dl = new DataLayer();
        this.showDispatch = this.showDispatch.bind(this);
    }

    showDispatch(item) {
        let test = ""
        this.props.history.push({
            pathname: '/salesforce/dispatchnote',
            search: 'invoiceid=' + item.sfInvoiceId + '&noteid=' + item.sfInvoiceDispatchNoteId
        })

    }

    async componentWillMount() {

        let params = this.props.location.search
        let response = await this.dl.Get("/common/GetDispatchList" + params);
        this.setState({
            dispatchList: response.data
        })
        this.props.loaderOff();
    }

    render() {
        return (
            <div>
                <Header headerText="Dispatch List" hideSearch={true} />
                <MDBRow>
                    {
                        this.state.dispatchList.map((item) => {
                            return (
                                <MDBCol xl="3" lg="6" md="6" sm="12" className="mb-r" >
                                    <MDBCard className="card-body" style={{ marginTop: "1rem" }}>
                                        <MDBCardTitle style={{ fontSize: "16px", paddingBottom: "3px" }}>
                                            <MDBIcon icon="truck" />&nbsp;Dispatch
                                        </MDBCardTitle>
                                        <MDBCardTitle style={{ fontSize: "14px" }}>
                                            &nbsp;<MDBIcon icon="hashtag" />&nbsp;Number:&nbsp;{item.sfInvoiceDispatchNoteId}
                                        </MDBCardTitle>
                                        <hr className="hr_grey" />
                                        <MDBCardText>
                                            <MDBIcon icon="user" />&nbsp;Dispatched By:&nbsp;{item.dispatchedBy}<br />
                                            <MDBIcon far icon="calendar-alt" />&nbsp;Week:&nbsp;{item.weekId}<br />
                                            <MDBIcon icon="hashtag" />&nbsp;Invoice No:&nbsp;{item.sfInvoiceId}<br />
                                            <MDBIcon icon="warehouse" />&nbsp;Area:&nbsp;{item.area};<br />
                                            {item.warehouse}
                                        </MDBCardText>
                                        <hr className="hr_grey" />
                                        <div className="flex-row text-center" >
                                            <MDBBtn rounded color="pink" size="sm" onClick={() => this.showDispatch(item)}>Dispatch Info</MDBBtn>
                                        </div>

                                    </MDBCard>
                                </MDBCol>
                            )
                        })
                    }
                </MDBRow>
            </div>
        )
    }
}

export default DispatchList;